import React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    ShowButton,
    TopToolbar,
    CreateButton,
    ExportButton,
    FilterButton,
    ReferenceField
} from 'react-admin';

const contactFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="name" source="name" name="Name" />,
    <TextInput label="email" source="name" name="Name" />
];

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

const ListTitle = () => {
    return (
        <span>
            { 'Companies House People' }
        </span>
    );
}

export const AdminCompaniesHousePeopleList = () => {

    return (
        <List
            title={ <ListTitle /> }
            actions={ <ListActions /> }
            filters={ contactFilters }>
            {/* Off, like the other 43 lists. It was on here only because nothing said otherwise, and
                what it offered was a bulk delete with no confirmation and no permission check:
                `BulkDeleteButton` does not ask `canAccess`. Deleting one record at a time from
                its own form still works, and asks first. */}
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="role" />
                <ReferenceField
                    label="Companies House For"
                    source="companiesHouses"
                    reference="companies_house"
                    link="show">
                    <TextField source="companyName" />
                </ReferenceField>
                <>
                    <ShowButton />
                    <EditButton />
                </>
            </Datagrid>
        </List>
    );

}